// src/components/Footer.js (GÜNCEL)
import React from "react";
import SITE from "../data/site.json";

export default function Footer() {
  const phoneItems = Array.isArray(SITE.phones) && SITE.phones.length > 0
    ? SITE.phones
    : (SITE.phone ? [{ label: "Telefon", number: SITE.phone }] : []);

  const formatTelHref = (raw) => {
    const digits = String(raw || "").replace(/\D/g, "");
    if (!digits) return "";
    if (digits.length === 11 && digits.startsWith("0")) return `+90${digits.slice(1)}`;
    if (digits.length === 10) return `+90${digits}`;
    if (digits.length === 12 && digits.startsWith("90")) return `+${digits}`;
    return `+${digits}`;
  };

  const formatTelHuman = (raw) => {
    const digits = String(raw || "").replace(/\D/g, "");
    if (!digits) return raw;
    let cc = ""; let local = digits;
    if (digits.startsWith("90") && digits.length === 12) { cc = "+90"; local = digits.slice(2); }
    else if (digits.startsWith("0") && digits.length === 11) { cc = "0"; local = digits.slice(1); }
    else if (digits.length === 10) cc = "+90";
    if (local.length === 10) {
      const a = local.slice(0, 3), b = local.slice(3, 6), c = local.slice(6, 8), d = local.slice(8, 10);
      if (cc === "0") return `0 (${a}) ${b} ${c} ${d}`;
      if (cc === "+90") return `+90 (${a}) ${b} ${c} ${d}`;
    }
    return raw;
  };

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-col">
          <h4>{SITE.companyName}</h4>
          <p>
            Hafriyat, kazı, yıkım ve dolgu çözümlerinde uzman ekip ve güçlü araç parkuru.
          </p>
        </div>

        <div className="footer-col">
          <h5>İletişim</h5>
          <ul className="list">
            {phoneItems.map((p, i) => (
              <li key={i}>
                {p.label}:{" "}
                <a href={`tel:${formatTelHref(p.number)}`}>
                  {formatTelHuman(p.number)}
                </a>
              </li>
            ))}
            <li>
              E-posta:{" "}
              <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
            </li>
            <li>Adres: {SITE.address}</li>
          </ul>
        </div>

        <div className="footer-col">
          <h5>Hızlı Bağlantılar</h5>
          <ul className="list">
            <li><a href="/services">Hizmetler</a></li>
            <li><a href="/projects">Referanslar</a></li>
            <li><a href="/contact">İletişim</a></li>
          </ul>
        </div>
      </div>

      <div className="copy">
        © {new Date().getFullYear()} {SITE.companyName}. Tüm hakları saklıdır.
      </div>
    </footer>
  );
}